export const getWorkerCode = (uuid) => `/**
 * Nexus Proxy - High Performance VLESS over WebSocket
 * Optimized for Cloudflare Pages / Workers
 */

import { connect } from 'cloudflare:sockets';

const userID = '${uuid}';
const proxyIPs = ['cdn.cloudflare.net', '104.16.89.20', '172.67.180.141'];

export default {
  async fetch(request, env, ctx) {
    try {
      const upgradeHeader = request.headers.get('Upgrade');
      if (!upgradeHeader || upgradeHeader !== 'websocket') {
        const url = new URL(request.url);
        if (url.pathname === '/health') return new Response('OK', { status: 200 });
        
        // Return the dashboard if someone visits the root
        return await env.ASSETS.fetch(request);
      }

      return await vlessOverWS(request);
    } catch (err) {
      return new Response(err.toString(), { status: 500 });
    }
  },
};

async function vlessOverWS(request) {
  const [client, server] = Object.values(new WebSocketPair());
  server.accept();

  let remoteSocket = null;
  let chunkCount = 0;

  server.addEventListener('message', async ({ data }) => {
    try {
      if (remoteSocket) {
        const writer = remoteSocket.writable.getWriter();
        await writer.write(data);
        writer.releaseLock();
        return;
      }

      // VLESS Header Parsing
      const view = new DataView(data);
      if (view.getUint8(0) !== 0) return; // Version check

      // UUID Validation (First 16 bytes after version)
      const clientUUID = Array.from(new Uint8Array(data.slice(1, 17)))
        .map(b => b.toString(16).padStart(2, '0')).join('');
      const cleanTargetUUID = userID.replace(/-/g, '');
      
      if (clientUUID !== cleanTargetUUID) {
        server.close();
        return;
      }

      // Address Processing
      const optLen = view.getUint8(17);
      const port = view.getUint16(18 + optLen);
      const atype = view.getUint8(20 + optLen);
      
      let address = '';
      let addressEnd = 21 + optLen;

      if (atype === 1) { // IPv4
        address = new Uint8Array(data.slice(21 + optLen, 25 + optLen)).join('.');
        addressEnd += 4;
      } else if (atype === 2) { // Domain
        const domainLen = view.getUint8(21 + optLen);
        address = new TextDecoder().decode(data.slice(22 + optLen, 22 + optLen + domainLen));
        addressEnd += 1 + domainLen;
      }

      const rawData = data.slice(addressEnd);
      
      // Connect to destination
      remoteSocket = connect({ hostname: address, port: port });
      
      const writer = remoteSocket.writable.getWriter();
      await writer.write(rawData);
      writer.releaseLock();

      // Remote -> Client
      remoteSocket.readable.pipeTo(new WritableStream({
        write(chunk) {
          server.send(chunk);
        },
        close() {
          server.close();
        }
      }));

    } catch (e) {
      server.close();
    }
  });

  return new Response(null, { status: 101, webSocket: client });
}
`;